import React, { useState, useEffect } from "react";
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";

import LinkReadToo from "../../../template/LinkReadToo";
import ShareBtns from "../../../template/ShareBtns";
import Loader from "../../../template/Loader";

import bannerImg from "../../../../assets/img/pesquisas/banner.jpg";

import Banner from "../../../template/Banner";

import api from "../../../../services/api";

import "./styles.css";

export default () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const description =
    "Lorem ipsum dolor sit, amet consectetur adipisicing elit.";

  useEffect(() => {
    (async function fetchNewsData() {
      setLoading(true);

      try {
        const { data } = await api.get(`/posts?category=2`);

        if (data.success) {
          setData(data.posts);
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="pesquisas">
      <Banner title="PESQUISAS" subtitle={description} img={bannerImg} />

      <MDBContainer className="mt-4">
        <ShareBtns
          title={document.title}
          description={description}
          image={bannerImg}
        />
      </MDBContainer>

      <div className="content container d-flex justify-content-center align-items-center flex-column">
        <MDBRow>
          <MDBCol md="8" sm="12">
            <h1>LOREM IPSUM</h1>
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cumque
              natus accusantium qui labore molestias. Consequuntur totam eaque
              vero suscipit fuga reprehenderit sit quia aspernatur, neque iusto
              optio, ab sed possimus? Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Autem libero commodi molestiae voluptate quas
              laborum ipsa rem magni? Eveniet accusamus fugit dicta porro omnis
              beatae impedit aspernatur quasi nihil minus.
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reiciendis adipisci molestias ipsam. Adipisci quasi est unde culpa
              eos quas rerum maiores atque architecto laborum libero quam,
              voluptatum aliquam, harum voluptatibus! Lorem ipsum dolor sit
              amet, consectetur adipisicing elit. Dolore, enim voluptatibus
              tenetur corporis sed fugit consequuntur voluptatum veritatis
              officia beatae suscipit quis adipisci, sint expedita odio soluta
              et. Eius, provident!
            </p>
          </MDBCol>
          <MDBCol md="4" sm="12">
            <h1>CONFIRA</h1>
            {loading ? (
              <Loader />
            ) : (
              data.length > 0 &&
              data.map((research) => (
                <LinkReadToo
                  key={research.id}
                  path={`/nossa-atuacao/pesquisas/${research.slug}`}
                  title={research.title}
                />
              ))
            )}
          </MDBCol>
        </MDBRow>
      </div>
    </div>
  );
};
